








import { Component, Vue } from "vue-property-decorator";
import ActivityViewer from "@/containers/ActivityViewer.vue";

@Component({
  components: { ActivityViewer }
})
export default class AuditLog extends Vue {}
